<script setup lang="ts">
defineProps<{
  headers: {
    key: string
    label: string
  }[]
}>()

const sortParams = defineModel<{
  key: string
  desc: boolean
}>('sortParams', {
  required: true
})

const checked = defineModel<boolean>('checked', {
  required: true
})

const emit = defineEmits({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  selectAll: (checked: boolean) => true,
  fetch: () => true
})

const handleSort = (k: string) => {
  let desc
  let key

  if (sortParams.value.key == k) {
    if (sortParams.value.desc) {
      key = ''
      desc = false
    } else {
      key = k
      desc = true
    }
  } else {
    key = k
    desc = false
  }

  sortParams.value = { key, desc }
  emit('fetch')
}
</script>

<template>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>
            <input type="checkbox" v-model="checked" class="main-checkbox" />
          </th>
          <th v-for="header in headers" :key="header.key">
            <div class="legend" :id="header.key + '-header'">
              {{ header.label.replace(/\s/g, '&nbsp;') }}
              <span
                class="material-symbols-outlined sort-by-arrow"
                @click="handleSort(header.key)"
                :class="{ active: sortParams.key === header.key, flip: sortParams.desc }"
                >arrow_downward</span
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
.table-container {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  width: 100%;
}

.sort-by-arrow {
  cursor: pointer;
  user-select: none;
  color: #777;

  transition:
    color 0.2s,
    text-shadow 0.2s,
    transform 0.2s;

  &.active {
    color: var(--theme-color);
    text-shadow: 0 0 1px #000;

    &.flip {
      transform: rotate(180deg);
    }
  }
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

input[type='checkbox'] {
  transform: scale(1.4);
}

th {
  padding: 0.1rem 0.5rem;
  border-bottom: 1px solid var(--theme-border-color);
  text-align: left;
}

tr {
  height: 32px;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-panel-secondary);
  }

  &.selected {
    background-color: var(--theme-panel-secondary);
  }
}

.legend {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.material-symbols-outlined {
  font-size: 1.25rem;
}
</style>
